<form class="contain" [formGroup]="pipelinesectionForm">
  <div class="pipeline_forms">
    <div class="the_card">
      <div class="section_details">
        <div class="main_pipeline-info">
          <div class="top">
            <!-- <h2 class="title">
                    <span class="pipeline_name">{{selectedPipelineDetails?.PipelineName}}</span> -
                    <span class="code">{{selectedPipelineDetails?.PipelineCode}}</span>
                </h2> -->

            <button
              class="default_secondary-btn"
              *ngIf="selectedPipelineDetails"
              (click)="onCreate()"
            >
              New Section <em class="ti-plus"></em> 
            </button>
          </div>

          <div class="other_info">
            <!-- <div class="detail">
                    <p class="entry">
                    <span class="item">License Status</span>:
                    <span class="value">{{getLicenceStatus(selectedPipelineDetails?.LicenceStatusId)}}</span>
                    </p>
                    <p class="entry">
                    <span class="item">Installation date</span>:
                    <span class="value">{{selectedPipelineDetails?.InstallationDate | date}}</span>
                    </p>
                    <p class="entry">
                    <span class="item">Expires</span>:
                    <span class="value">{{selectedPipelineDetails?.LicenceExpirationDate | date}}</span>
                    </p>
                </div> -->

            <div class="section_entered">
              <p class="inform" *ngIf="pipelinesections">
                {{ pipelinesections?.length }} sections Entered
              </p>
              <button
                class="section_btn"
                (click)="onPatchValue(item)"
                *ngFor="let item of sectionList; index as i"
              >
                {{ item.PipelineSectionName
                }}<em class="ti-close" (click)="onDelete(item, i)"></em> 
              </button>
            </div>
          </div>
        </div>

        <div class="section_info">
          <div class="one">
            <div class="input">
              <label for="">Pipeline Section Name</label>
              <input
                type="text"
                class="default_input"
                formControlName="PipelineSectionName"
              />
            </div>
            <div class="input">
              <label for="">Asset Status</label>
              <select class="default_input" formControlName="AssetStatusId">
                <option
                  class="option"
                  *ngFor="let asset of assetstatuss"
                  [value]="asset.id"
                >
                  {{ asset.AssetStatusName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Network</label>
              <select class="default_input" formControlName="NetworkId">
                <option
                  class="option"
                  *ngFor="let network of networks"
                  [value]="network.id"
                >
                  {{ network.NetworkName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Pigibility</label>
              <select class="default_input" formControlName="PigibilityId">
                <option
                  class="option"
                  *ngFor="let pigi of pigibilitys"
                  [value]="pigi.id"
                >
                  {{ pigi.PigibilityName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">IP Status</label>
              <select class="default_input" formControlName="IpStatusId">
                <option
                  class="option"
                  *ngFor="let ips of ipstatuss"
                  [value]="ips.id"
                >
                  {{ ips.IPStatusName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Asset Location</label>
              <select
                class="default_input"
                formControlName="PipelineAssetLocationId"
              >
                <option
                  class="option"
                  *ngFor="let location of assetlocations"
                  [value]="location.id"
                >
                  {{ location.PipelineAssetLocationName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Pipeline Grade</label>
              <select class="default_input" formControlName="PipelineGradeId">
                <option
                  class="option"
                  *ngFor="let pipeline of pipelinegrades"
                  [value]="pipeline.id"
                >
                  {{ pipeline.PipelineGradeName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Delivery Type</label>
              <select class="default_input" formControlName="DeliveryTypeId">
                <option
                  class="option"
                  *ngFor="let deliverytype of deliverytypes"
                  [value]="deliverytype.id"
                >
                  {{ deliverytype.DeliveryTypeName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">License Status</label>
              <select class="default_input" formControlName="LicenceStatusId">
                <option
                  class="option"
                  *ngFor="let licences of licencestatuss"
                  [value]="licences.id"
                >
                  {{ licences.LicenceStatusName }}
                </option>
              </select>
            </div>
          </div>

          <div class="heading">Measurement</div>

          <div class="one">
            <div class="input">
              <label for="">Length</label>
              <input
                type="number"
                class="default_input"
                formControlName="Length"
              />
            </div>
            <div class="input">
              <label for="">Length Unit of Measure</label>
              <select class="default_input" formControlName="LengthUOMId">
                <option
                  class="option"
                  *ngFor="let uom of lengthUnitOfMeasures"
                  [value]="uom.id"
                >
                  {{ uom.UomName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Diameter</label>
              <input
                type="number"
                class="default_input"
                formControlName="Diameter"
              />
            </div>
            <div class="input">
              <label for="">Diameter Unit of Measure</label>
              <select class="default_input" formControlName="DiameterUOMId">
                <option
                  class="option"
                  *ngFor="let uom of diameterUnitOfMeasures"
                  [value]="uom.id"
                >
                  {{ uom.UomName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Wall Thickness</label>
              <input
                type="number"
                class="default_input"
                formControlName="WallThickness"
              />
            </div>
            <div class="input">
              <label for="">Wall Thickness Unit of Measure</label>
              <select
                class="default_input"
                formControlName="WallThicknessUOMId"
              >
                <option
                  class="option"
                  *ngFor="let uom of wallThicknessUnitOfMeasures"
                  [value]="uom.id"
                >
                  {{ uom.UomName }}
                </option>
              </select>
            </div>
            <div class="input">
              <label for="">Designed Pressure</label>
              <input
                type="number"
                class="default_input"
                formControlName="DesignedPressure"
              />
            </div>
            <div class="input">
              <label for="">Designed Pressure Unit of Measure</label>
              <select
                class="default_input"
                formControlName="DesignedPressureUOMId"
              >
                <option
                  class="option"
                  *ngFor="let uom of pressureUnitOfMeasures"
                  [value]="uom.id"
                >
                  {{ uom.UomName }}
                </option>
              </select>
            </div>
          </div>

          <div class="submit">
            <button
              class="default_primary-button"
              *ngIf="!pipelinesections[0]"
              (click)="onSubmit(pipelinesectionForm.value)"
            >
              Save
            </button>
            <button
              class="default_primary-button"
              *ngIf="pipelinesections[0]"
              (click)="onSubmit(pipelinesectionForm.value)"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
